import * as React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { createTheme } from '@material-ui/core';
import { withStyles, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import { fontFamilies } from '../../theme/text';

interface Props {
  date: moment.Moment | string;
  label: string;
  changeDate: (date: string | null) => void;
}

const materialTheme = createTheme({
  overrides: {
    // @ts-ignore
    root: {
      width: 126
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#1b7cbb'
      }
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: `#1b7cbb`
      }
    },
    MuiButton: {
      textPrimary: {
        color: `#1b7cbb`
      }
    },
    MuiOutlinedInput: {
      root: {
        width: '100%',
        height: '100%',
        paddingBottom: 8,
        '&$focused $notchedOutline': {
          borderColor: '#00AAFC'
        }
      },
      input: {
        fontFamily: fontFamilies.body,
        fontWeight: 300,
        letterSpacing: '0.3px',
        fontSize: 14,
        paddingLeft: 6
      },
      adornedEnd: {
        paddingRight: 6,
        paddingTop: 6
      }
    },
    MuiSvgIcon: {
      root: {
        fill: '#4f4f4f',
        width: 22,
        height: 22
      }
    },
    MuiIconButton: {
      root: {
        padding: 0
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: fontFamilies.heading,
        fontWeight: 300,
        color: '#4f4f4f !important',
        fontSize: 14,
        '&$focused': {
          color: '#4f4f4f !important'
        }
      }
    }
  }
});

const DatePicker = withStyles({
  root: {
    fontSize: '12px',
    height: 40,
    width: 126,
    marginBottom: 17,

    '& .MuiInputLabel-outlined': {
      transform: 'translate(8px, 14px) scale(1)',
      fontSize: 14
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important'
    }
  }
})(KeyboardDatePicker);

const FilterDatePicker = ({ date, label, changeDate }: Props) => {
  const handleChange = date => {
    changeDate(date);
  };

  return (
    <ThemeProvider theme={materialTheme}>
      <DatePicker
        autoOk
        value={date}
        onChange={(date, value) => handleChange(date)}
        inputVariant="outlined"
        format="MM/DD/YYYY"
        emptyLabel="__/__/____"
        label={label}
        invalidDateMessage=" "
        minDateMessage=" "
        maxDateMessage=" "
        InputLabelProps={{ shrink: true }}
      />
    </ThemeProvider>
  );
};

export default FilterDatePicker;
